import { memo } from 'react';
import { Box, styled, Typography } from '@mui/material';
import { Handle, type Node, type NodeProps, Position } from '@xyflow/react';
import { ActionNodeContent } from './action-node-content';
import type { ActionNodeData } from '../../../mappers/map-canvas-content.types';

export const ActionNode = memo(({ data, selected }: NodeProps<Node<ActionNodeData, 'action'>>) => {
  return (
    <NodeWrapper className="nopan" selected={selected}>
      <HeaderWrapper>
        <TitleWrapper>
          <Typography variant="caption" fontWeight={700}>
            Action
          </Typography>
        </TitleWrapper>
      </HeaderWrapper>
      <ActionNodeContent data={data} />
      <Handle type="target" position={Position.Left} isConnectable={false} />
      <Handle type="source" position={Position.Right} isConnectable={false} />
    </NodeWrapper>
  );
});

const NodeWrapper = styled(Box)<{ selected?: boolean }>(({ theme, selected }) => ({
  position: 'relative',
  backgroundColor: theme.palette.lwWhite[100],
  border: `1px solid ${selected ? theme.palette.primary.main : theme.palette.lwSecondaryAccentLight[20]}`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(2),
  maxWidth: 320,
  maxHeight: 250,
  boxShadow: selected ? `0 0 0 2px ${theme.palette.primary.main}` : 'none',
}));

const HeaderWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 8,
});

const TitleWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});
